import React from 'react'
import './BigHero.css'
import LanNavbar from '../../Components/Navbar/LanNavbar'
import LanHero from '../../Components/Hero/LanHero'

function BigHero() {
    return (
        <div id='bg'>
            <LanNavbar/>
            <LanHero/>
        </div>
    )
}

export default BigHero
